/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax

Vue.use(Vuesax);

import filtering from './modules/accounts/Permissionfiltering'
Vue.prototype.filtering = filtering.filtering
//过滤商品特殊字符（MK.....）
import {filterStr} from '../src/utils/validateUtil';
Vue.prototype.filterStr = filterStr;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import axios from 'axios'
Vue.prototype.$http = axios
// Theme Configurations
import "../themeConfig.js";
// Globally Registered Components
import "./globalComponents.js";
// Styles: SCSS
import "./assets/scss/main.scss";
// Tailwind
import "@/assets/css/main.css";
import "@/assets/group-cloud/custom.scss";
// Vue Router
import router from "./router";
// Vuex Store
import store from "./store/store";

// Vuexy Admin Filters
import "./filters/filters";

// VeeValidate
import VeeValidate from "vee-validate";

import zh_CN from "vee-validate/dist/locale/zh_CN";
Vue.use(VeeValidate);
VeeValidate.Validator.localize("zh_CN", {
    // 设置了这个之后提示信息会变成中文的
    messages: zh_CN.messages,
    // 属性的提示信息
    attributes: { phone: "手机号码", password: "密码" }
});

// 下拉选择框 https://www.vue-select.cn/guide/install.html
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
// 时间选择 https://github.com/ankurk91/vue-flatpickr-component
import vDateSelect from "@/components/v-date-select/index";
Vue.component("v-date-select", vDateSelect);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

import { SuperDebug } from "./utils/debug/Sdebug";
global.SuperDebug = SuperDebug;

import Server from "./h5_src/network/server";
Vue.use(Server);

import { MixinVariables } from "./h5_src/mixin/mixin";
Vue.mixin(MixinVariables);

//引入elementui 上传文件
import Upload from "./components/element-ui/el-upload/index";
Vue.component("el-upload",Upload);

// Feather font icon
require("./assets/css/iconfont.css");


//修改分页插件
import GcVsPagination from '@/group-cloud/components/vsPagination/vsPagination'
Vue.component('gc-vs-pagination', GcVsPagination)

import GcVsPaginationNoSize from '@/group-cloud/components/vsPagination/vsPaginationNoSize'
Vue.component('gc-vs-pagination-nosize', GcVsPaginationNoSize)

//金额格式化:默认显示￥
var currency = require('currency.js');
Vue.filter('currencyFormat', function (value, precision, noSymbolFlag, symbolType) {
  //精度
  precision = precision ? precision : 2;
  let symbol = noSymbolFlag ? '' : (symbolType ? symbolType : '￥');
  if(Number(value) != 'NaN'){
    return currency(value, {precision:2, symbol: symbol , separator:','}).format();
  }else{
    return value;
  }
})



Vue.config.productionTip = false;
let doMainFunc = {install: function(Vue, options) {

        Vue.prototype.$doMainFunc = function(uri, data = {}) {
                  let hostName = window.location.hostname;
                  let title = '';
                  switch (hostName) {
                      case 'test.yoozworld.cn':
                          title = 'Yooz'
                          break;
                      case 'uat.yoozworld.cn':
                          title = 'Yooz'
                          break;
                      case 'om.yoozworld.cn':
                          title = 'Yooz'
                          break;
                      case 'ldj.yoozworld.cn':
                          title = '力当家'
                          break;
                      case 'ldj-test.yoozworld.cn':
                          title = '力当家'
                          break;
                      case 'wyx.yoozworld.cn':
                          title = '雾以希'
                          break;
                      case 'wyx-test.yoozworld.cn':
                          title = '雾以希'
                          break;
                      case 'wyx-uat.yoozworld.cn':
                          title = '雾以希'
                          break;
                      case 'dev.yoozworld.cn':
                          title = 'Yooz'
                          break;
                      case 'test.asmyun.com':
                          title = 'Yooz'
                          break;
                      default:
                          title = '雾以希'
                  }
                  document.title = title;
                  return title;
        };

    }};
Vue.use(doMainFunc);
import $globals from "./h5_src/framework/Globals";
import {ServerBizApi} from "./group-cloud/network/ServerBizApi";

$globals.$vm = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
